import {
  API_ENDPOINT,
  useClientApiV1AccountsMyProfileQuery,
} from '../../resources/@types/accountSchema';

function useClientAccountMyProfileQuery(
  options?: Parameters<typeof useClientApiV1AccountsMyProfileQuery>[0]['options'],
) {
  return useClientApiV1AccountsMyProfileQuery({
    queryKey: [API_ENDPOINT.CLIENT_V1_ACCOUNTS_MY_PROFILE],
    url: API_ENDPOINT.CLIENT_V1_ACCOUNTS_MY_PROFILE,
    options,
  });
}

useClientAccountMyProfileQuery.queryKey = [API_ENDPOINT.CLIENT_V1_ACCOUNTS_MY_PROFILE];

export default useClientAccountMyProfileQuery;
